(function () {
  "use strict";

  angular
    .module("app")
    .directive("searchStop", searchStop);

  function searchStop() {
    // Usage:
    //
    // Creates:
    //
    var directive = {
      link: link,
      restrict: "E",
      templateUrl: "/app/search/search.template.html",
      scope: {
        labelText: "@",
        labelClass: "@",
        sortableItemIndex: "=",
        hideClose: "="
      }
    };
    return directive;

    function link($scope, $element, $attrs) {
      $scope.labelText = $attrs.labelText;
      $scope.labelClass = $attrs.labelClass;
    }
  }
})();



// WEBPACK FOOTER //
// ./app/search/search.directive.js